import { render, staticRenderFns } from "./List.Partial.vue?vue&type=template&id=1867112c"
import script from "./List.Partial.vue?vue&type=script&lang=js"
export * from "./List.Partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports